import React from "react";
import CodesList from "../../Codes/CodesList";

const CodeCell = ({ codes }) => (
  <CodesList maxCount={3} maxCountInRow={2} codes={codes} />
);

export default CodeCell;
